<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <form [formGroup]="pageForm">
            <h1 class="font-bold text-xl">{{title}}</h1>
            <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
            @if(pageForm.errors) {
            <div class="mt-2 w-full bg-red-200 border-l-2 border-l-red-500">
                <p class="text-primary-500 text-xs px-2 py-1">{{pageForm.errors | json}}</p>
            </div>
            }

            <div class="w-full mt-4">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Certificate Name *
                </label>
                <input type="text" id="awardName" formControlName="awardName" name="awardName" required
                    class="placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow w-full py-2 px-3 ease-linear transition-all duration-150 border focus:outline-none focus:ring-0" />
                <div
                    class="{{ pageForm.get('awardName')?.invalid && (pageForm.get('awardName')?.dirty || pageForm.get('awardName')?.touched) ? 'visible' : 'invisible'}} pt-1 h-6 text-red-500 text-xs">
                    @if(pageForm.get('awardName')?.errors?.['required']) {
                    <p>Value is required</p>
                    }
                </div>
            </div>

            <div class="w-full flex flex-col mt-1">
                <app-s3-document-upload #uploader label="Upload Pdf" [preSignedUrlEndpoint]="preSignedUrlEndpoint"
                    [formats]="['.pdf']" [apikey]="apiKey" [maxFileSize]="maxFileSize"
                    [cloudFrontDomain]="cloudFrontDomain"></app-s3-document-upload>
            </div>

            <div class="mt-4 flex flex-row gap-4 justify-end">
                <button type="button" (click)="onCancel()"
                    class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
                <button type="submit" (click)="submit()" [disabled]="pageForm.invalid || !uploader.getIsAttached()"
                    class="bg-primary-500 disabled:bg-primary-100 disabled:text-primary-500 text-white rounded font-semibold px-4 py-2 focus:outline-none">{{action}}</button>
            </div>
        </form>
    </div>
</div>